import statusIcon from "../styles/img/NewPackSelector/table-heading-icon1.svg";
import premiumIcon from "../styles/img/NewPackSelector/table-heading-icon2.svg";

const headerDetails = (first_price, second_price, feesPrice) => {

  const isAbTestProduct = [175, 197, 176, 198].indexOf(lpApp.contractMetaId) > -1
  
  return [
    {
      title: "Création Standard",
      subTitle: "On s'occupe de tout",
      price: `${second_price}€`,
      fees: true,
      id: 1,
      info: feesPrice ? displayFeesText(feesPrice) : null
    },
    {
      title: "Création Express",
      subTitle:  "Traité sous 24H",
      price: `${first_price}€`,
      fees: true,
      id: 0,
      info: feesPrice ? displayFeesText(feesPrice) : null
    },
    {...isAbTestProduct && {
      title: "Création Offerte",
      subTitle: "Expert Comptable",
      price: 'Offerte',
      id: 3,
      info: feesPrice ? displayFeesText(feesPrice) : null,
    }}
  ]
}

const faq  = (contractName) => [
  {
    question: "Pourquoi choisir LegalPlace ?",
    answer:
      "LegalPlace vous permet de créer votre société facilement, rapidement, et sans aucun risque de rejet par le greffe. Vos statuts sont parfaitement fiables juridiquement et adaptés à votre société. Nos experts sont disponibles par email et téléphone pour répondre à vos questions et créent votre société en un temps record grâce à leur expérience et leur relations avec les greffes et autres administrations. De plus, comme nous souhaitons vous donner un coup de pouce pour la création de votre société, nous vous proposons de payer les frais de services et les frais administratifs en 3 fois sur 3 mois, sans aucun frais supplémentaire."
  },
  {
    question: "En combien de temps aurai-je mon K-bis?",
    answer:
      "Une fois votre dossier complet, nos experts lancent sous 24h* (formule express uniquement) toutes les démarches auprès du greffe et du journal d’annonce légale pour immatriculer votre société au plus vite. Vous recevrez alors votre Kbis en moyenne une semaine après (variable selon les départements)."
  },
  {
    question: "Que se passe-t-il après le paiement ?",
    answer:
      `Une fois le paiement effectué, vous serez redirigés vers un questionnaire avec des questions complémentaires sur votre ${contractName}. Une fois le questionnaire complété, vos statuts seront générés automatiquement et nos experts traiterons votre dossier en moins de 24h* (formule Express uniquement). Vous recevrez alors vos statuts nécessaires à l’ouverture de votre compte bancaire. Une fois votre compte bancaire ouvert, nos experts s’occupent de tout jusqu’à l’obtention de votre Kbis.`
  },
  {
    question: "Comment récupérer la TVA ?",
    answer:
      `Les frais de création sont avancés par un ou plusieurs associés pour le compte de la société en formation. Les associés qui ont avancé les coûts de création de ${contractName} se remboursent une fois les fonds du compte bancaire de la société débloqués – et à condition que la ${contractName} dispose de la trésorerie suffisante. La TVA afférente aux frais de création est déductible dans le cadre des activités de la société.`
  }
]

const displayFeesText = (feesPrice) => `+ frais administratifs (${feesPrice.toFixed(2).toString().replace('.', ',')}€)`

const getCompanyCreationDetails = companyType => {
  const isAbTestProduct = [175, 197, 176, 198].indexOf(lpApp.contractMetaId) > -1
  return [
  {
    text: "Statuts",
    isHeading: true,
    icon: statusIcon
  },
  {
    title: `Statuts de ${companyType}`,
    included: [true, true, true],
    content:
      `Vous recevez vos statuts de ${companyType} personnalisés grâce aux réponses renseignées dans le questionnaire. Vous recevrez également le M0, les pièces annexes obligatoires et le registre des bénéficiaires effectifs`
  },
  {
    title: "Vérification du dossier",
    included: [true, true, true],
    content:
      "Nos formalistes vérifient et valident votre dossier, ils prennent contact avec vous au besoin"
  },
  // Header 2
  {
    text: "Nos experts juridiques prennent en charge votre dossier",
    isHeading: true,
    icon: premiumIcon
  },
  // Content 2
  {
    title: "Immatriculation auprès du greffe",
    included: [true, true, true],
    content:
      "Nous faisons les démarches nécessaire pour immatriculer votre société auprès du greffe"
  },
  {
    title: "Garantie anti-rejet",
    included: [true, true, true],
    content:
      "Il arrive parfois que le greffe rejette des dossiers afin de demander des informations complémentaires. Nos experts gèrent tous les cas de rejet"
  },
  {
    title: "Publication de l'annonce légale",
    included: [true, true, true],
    content:
      "Formalité obligatoire dans le cadre d'une constitution de société"
  },
  {
    title: "Obtention du kbis et du SIRET",
    included: [true, true, true],
    content:
      "Vous obtiendrez votre Kbis après vérification de votre dossier dans un délai de 8 jours en moyenne"
  },
  {
    title: "Traitement express (24h)",
    included: [false, true, true],
    content:
      "Nous traiterons votre dossier sous 24h. L'obtention de votre numéro SIRET peut cependant prendre 8 à 12 jours"
  },
  {
    title: "Assistance téléphonique illimitée",
    included: [false, true, true],
    content: "Nos experts sont disponibles pour vous aider"
  },
  {...isAbTestProduct ? {
    title: "Solution complète d’expertise comptable",
    included: [false, false, true],
    content: "Vous bénificiez d’un expert comptable dédié ainsi que d’un logiciel de facturation"
  } : null},
]}

const todoOptions = ["Préparer et vérifier le dossier complet", "Demander l’immatriculation auprès du greffe", "Gérer les échanges avec le greffe", "Faire la publication de l'annonce légale"]

const todoOptionsEC = ['Vous payez uniquement les frais administratifs obligatoires', 'Après le paiement, un conseiller vous contacte pour vous présenter les modalités de la solution d’expertise comptable', 'Si vous souhaitez vous rétracter par la suite, nous vous remboursons à 100%']

const extraPackOptionsBottom = (companyType) => [`Status de ${companyType}`]
const extraPackOptionsEC = ['Tous les services du pack <br><b>Création Express</br>', 'Solution d’expertise <br>comptable']


export const getGlobalData = ({ first_price, second_price, third_price }, feesPrice) => {
  return {
    // creation-sci 3 packs
    124: {
      headerTitle: "Votre SCI est prête à être créée",
      packHeaderDetails: headerDetails(first_price, second_price, feesPrice),
      faq: faq('SCI'),
      contentInfoDetails: getCompanyCreationDetails('SCI'),
      extraPacksBottom: [
        {
          title: "Statuts seuls",
          subTitle: "Vous créez seul",
          price: `${third_price}€`,
          options: extraPackOptionsBottom("SCI"),
          todoOptions,
          id: 2,
          sectionTitles: ['Ce pack contient', 'Ce qu’il vous reste à faire']
        }
      ]
    },
    // Association: cr-ez-votre-association 162 
    162: {
      headerTitle: "Votre association est prête à être créée",
      packHeaderDetails: [
        {
          title: "Statuts seuls",
          subTitle: "Vous créez seul",
          price: `${second_price}€`,
          fees: true,
          id: 1
        },
        {
          title: "Création Express",
          subTitle: "On s'occupe de tout",
          price: `${first_price}€`,
          fees: true,
          id: 0,
          info: "Possibilité de payer en 3 fois"
        }
      ],
      faq: [
        {
          question: "Pourquoi choisir LegalPlace ?",
          answer:
            "LegalPlace vous permet de créer votre association facilement, rapidement, et sans aucun risque de rejet par la préfecture. Inutile de s’y connaître en droit ou en démarches administratives : nos experts s’occupent de tout. Vos statuts sont générés automatiquement grâce à vos réponses à notre questionnaire et sont parfaitement adaptés à votre association. Nos experts sont disponibles par email et téléphone pour répondre à vos questions et réalisent toutes les formalités administratives en un temps record grâce à leur expérience et leur relations avec les administrations. De plus, comme nous souhaitons vous donner un coup de pouce pour la création de votre association, nous vous proposons de nous régler en 3 fois sur 3 mois, sans aucun frais supplémentaire."
        },
        {
          question: "En combien de temps mon association sera-t-elle créée ?",
          answer:
            "Une fois votre dossier complet, nos experts lancent sous 24h toutes les démarches pour créer votre association au plus vite. La création de votre association sera publiée au Journal Officiel des Association sous 7 à 10 jours et votre association sera alors officiellement créée !"
        },
        {
          question: "Que se passe-t-il après le paiement ?",
          answer:
            "Une fois le paiement effectué, vous serez redirigés vers un questionnaire avec des questions complémentaires sur votre association. Une fois le questionnaire complété, vos statuts seront générés automatiquement. Nos experts traiterons alors votre dossier en moins de 24h* et vous contacterons en cas de besoin."
        },
        {
          question: "Comment personnaliser les statuts de mon association ?",
          answer:
            "Une fois le paiement effectué, vous serez redirigé vers un questionnaire qui vous demandera si vous souhaitez des statuts standards ou si vous souhaitez avoir un conseil d'administration, personnaliser les conditions d’adhésion, ajouter un président d’honneur, etc. Les statuts de votre association seront alors automatiquement modifiés en fonction de vos réponses."
        }
      ],
      contentInfoDetails: [
        // Header 1
        {
          text: "Statuts",
          isHeading: true,
          icon: statusIcon
        },
        // Content 1
        {
          title: "Statuts d'association",
          included: [true, true],
          content:
            "Vous recevez vos statuts d’association personnalisés grâce aux réponses renseignées dans le questionnaire"
        },
        {
          title: " Dossier complet",
          included: [true, true],
          content:
            "PV d'assemblée générale constitutive, Bulletin d'adhésion (pour les nouveaux nembres), Reçu de cotisation d'adhésion, Reçu fiscal de don(pour les déductions d'impôts en cas de don)"
        },
        // Header 2
        {
          text: "Nos experts juridiques prennent en charge votre dossier",
          isHeading: true,
          icon: premiumIcon
        },
        // Content 2
        {
          title: "Enregistrement de l'association",
          included: [false, true],
          content:
            "Revue de votre dossier, échanges entre nos experts et vous en cas de besoin, puis dépôt de votre dossier à la préfecture"
        },
        {
          title: "Échanges avec la préfecture",
          included: [false, true],
          content:
            "En cas de rejet de votre dossier après instruction par les autorités administratives, nous vous assistons dans la reprise de votre dossier pour effectuer un nouveau dépôt"
        },
        {
          title: "Assistance obtention du SIRET",
          included: [false, true],
          content:
            "Nous vous préparons les pièces nécessaires pour l'obtention du numéro SIRET de votre association si vous envisagez d'en solliciter un (nécessaire dans certains cas)"
        },
        {
          title: "Traitement express (24h)",
          included: [false, true],
          content:
            "Nous traiterons votre dossier sous 24h. L'obtention de votre numéro SIRET peut cependant prendre 10 à 15 jours"
        },
        {
          title: "Assistance téléphonique illimitée",
          included: [false, true],
          content: "Nos experts sont disponibles pour vous aider"
        }
      ],
    },

    // Créez votre auto entreprise || creez-votre-micro-entreprise
    181: {
      headerTitle: "Votre auto entreprise est prête à être créée",
      packHeaderDetails: headerDetails(first_price, second_price, feesPrice),
      faq: [
        {
          question: "Pourquoi choisir LegalPlace ?",
          answer:
            "LegalPlace vous permet de créer votre micro-entreprise en toute simplicité. Une fois vos réponses à notre questionnaire complétées, nos experts s’occupent de toutes les démarches administratives jusqu’à l’obtention de votre numéro SIREN. De plus, comme nous souhaitons vous donner un coup de pouce pour la création de votre auto-entreprise, nous vous proposons de nous régler en 3 fois sur 3 mois, sans aucun frais supplémentaire."
        },
        {
          question: "En combien de temps mon auto-entreprise sera créée ?",
          answer:
            "Une fois votre dossier complet, nos experts lancent sous 24h (formule Express uniquement) toutes les démarches pour immatriculer votre auto-entreprise au plus vite. Vous obtiendrez alors votre numéro SIREN sous 10 à 30 jours en moyenne (variable selon les départements)."
        },
        {
          question: "Que se passe-t-il après le paiement ?",
          answer:
            "Une fois le paiement effectué, vous serez redirigés vers un questionnaire avec des questions complémentaires. Une fois le questionnaire complété, nos experts traiterons votre dossier en moins de 24h* (formule Express uniquement) et vous contacterons en cas de besoin."
        },
        {
          question: "Qu’est-ce que la demande d’ACCRE ?",
          answer:
            "L’ACCRE correspond à « Aide aux demandeurs d'emploi créant ou reprenant une entreprise ». Le dispositif consiste en une exonération de charges sociales pendant un an à partir du moment de l'immatriculation de la société ou au début de son activité. Si vous choisissez la formule Express, nos experts réalisent la demande d’Accre pour vous."
        }
      ],
      contentInfoDetails: [
        // Header 1
        {
          text: "Statuts",
          isHeading: true,
          icon: statusIcon
        },
        // Content 1
        {
          title: "Dossier juridique complet",
          included: [true, true],
          content:
            "Vous recevez le formulaire P0 complété ainsi que l'intégralité des documents juridiques nécessaires à la création de la micro-entreprise"
        },
        {
          title: "Vérification du dossier",
          included: [true, true],
          content:
            "Nos formalistes vérifient et valident votre dossier, ils prennent contact avec vous au besoin"
        },
        // Header 2
        {
          text: "Nos experts juridiques prennent en charge votre dossier",
          isHeading: true,
          icon: premiumIcon
        },
        // Content 2
        {
          title: "Immatriculation auprès du greffe",
          included: [true, true],
          content:
            "Nous faisons les démarches nécessaire pour immatriculer votre société auprès du greffe"
        },
        {
          title: "Garantie anti-rejet",
          included: [true, true],
          content:
            "Il arrive parfois que le greffe rejette des dossiers afin de demander des informations complémentaires. Nos experts gèrent tous les cas de rejet"
        },
        {
          title: "Obtention du kbis et du SIRET",
          included: [true, true],
          content:
            "Vous obtiendrez votre Kbis après vérification de votre dossier dans un délai de 8 jours en moyenne"
        },
        {
          title: "Traitement express (24h)",
          included: [false, true],
          content:
            "Nous traiterons votre dossier sous 24h. L'obtention de votre numéro SIRET peut cependant prendre 8 à 12 jours"
        },
        {
          title: "Assistance téléphonique illimitée",
          included: [false, true],
          content: "Nos experts sont disponibles pour vous aider"
        },
        {
          title: "Obtention de l'ACRE (ex ACCRE)",
          included: [false, true],
          content: "Nous nous chargeons de compléter pour vous votre formulaire ACRE afin de vous permettre de bénéficier des réductions d'impôts dédiées au créateur d'entreprise"
        },
      ],
    },

    // Créez votre auto entreprise artisan || devenir-artisan
    680: {
      headerTitle: "Votre auto entreprise est prête à être créée",
      packHeaderDetails: [
        {
          title: "Création Standard",
          subTitle: "On s'occupe de tout",
          price: `${second_price}€`,
          fees: true,
          id: 1,
          info: Boolean(feesPrice) && `+ ${feesPrice}€ de frais d’inscription à la CMA` 
        },
        {
          title: "Création Express",
          subTitle: "Traité sous 24H",
          price: `${first_price}€`,
          fees: true,
          id: 0,
          info: Boolean(feesPrice)  && `+ ${feesPrice}€ de frais d’inscription à la CMA` 
        }
      ],
      faq: [
        {
          question: "Pourquoi choisir LegalPlace ?",
          answer:
            "LegalPlace vous permet de créer votre micro-entreprise en toute simplicité. Une fois vos réponses à notre questionnaire complétées, nos experts s’occupent de toutes les démarches administratives jusqu’à l’obtention de votre numéro SIREN. De plus, comme nous souhaitons vous donner un coup de pouce pour la création de votre auto-entreprise, nous vous proposons de nous régler en 3 fois sur 3 mois, sans aucun frais supplémentaire."
        },
        {
          question: "En combien de temps mon auto-entreprise sera créée ?",
          answer:
            "Une fois votre dossier complet, nos experts lancent sous 24h (formule Express uniquement) toutes les démarches pour immatriculer votre auto-entreprise au plus vite. Vous obtiendrez alors votre numéro SIREN sous 10 à 30 jours en moyenne (variable selon les départements)."
        },
        {
          question: "Que se passe-t-il après le paiement ?",
          answer:
            "Une fois le paiement effectué, vous serez redirigés vers un questionnaire avec des questions complémentaires. Une fois le questionnaire complété, nos experts traiterons votre dossier en moins de 24h* (formule Express uniquement) et vous contacterons en cas de besoin."
        },
        {
          question: "Qu’est-ce que la demande d’ACCRE ?",
          answer:
            "L’ACCRE correspond à « Aide aux demandeurs d'emploi créant ou reprenant une entreprise ». Le dispositif consiste en une exonération de charges sociales pendant un an à partir du moment de l'immatriculation de la société ou au début de son activité. Si vous choisissez la formule Express, nos experts réalisent la demande d’Accre pour vous."
        }
      ],
      contentInfoDetails: [
        // Header 1
        {
          text: "Statuts",
          isHeading: true,
          icon: statusIcon
        },
        // Content 1
        {
          title: "Dossier juridique complet",
          included: [true, true],
          content:
            "Vous recevez le formulaire P0 complété ainsi que l'intégralité des documents juridiques nécessaires à la création de la micro-entreprise"
        },
        {
          title: "Vérification du dossier",
          included: [true, true],
          content:
            "Nos formalistes vérifient et valident votre dossier, ils prennent contact avec vous au besoin"
        },
        // Header 2
        {
          text: "Nos experts juridiques prennent en charge votre dossier",
          isHeading: true,
          icon: premiumIcon
        },
        // Content 2
        {
          title: "Immatriculation auprès du greffe",
          included: [true, true],
          content:
            "Nous faisons les démarches nécessaire pour immatriculer votre société auprès du greffe"
        },
        {
          title: "Garantie anti-rejet",
          included: [true, true],
          content:
            "Il arrive parfois que le greffe rejette des dossiers afin de demander des informations complémentaires. Nos experts gèrent tous les cas de rejet"
        },
        {
          title: "Obtention du kbis et du SIRET",
          included: [true, true],
          content:
            "Vous obtiendrez votre Kbis après vérification de votre dossier dans un délai de 8 jours en moyenne"
        },
        {
          title: "Traitement express (24h)",
          included: [false, true],
          content:
            "Nous traiterons votre dossier sous 24h. L'obtention de votre numéro SIRET peut cependant prendre 8 à 12 jours"
        },
        {
          title: "Assistance téléphonique illimitée",
          included: [false, true],
          content: "Nos experts sont disponibles pour vous aider"
        },
        {
          title: "Obtention de l'ACRE (ex ACCRE)",
          included: [false, true],
          content: "Nous nous chargeons de compléter pour vous votre formulaire ACRE afin de vous permettre de bénéficier des réductions d'impôts dédiées au créateur d'entreprise"
        }
      ],
    },

    ///creation-sarl
    197: {
      headerTitle: "Votre SARL est prête à être créée",
      packHeaderDetails: headerDetails(first_price, second_price, feesPrice),
      faq: faq('SARL'),
      contentInfoDetails: getCompanyCreationDetails('SARL'),
      extraPacksEC: [
        {
          title: "Création Offerte",
          subTitle: "Expert Comptable",
          price: 'Offerte',
          options: extraPackOptionsEC,
          todoOptions: todoOptionsEC,
          info: feesPrice ? displayFeesText(feesPrice) : null,
          id: 3,
          sectionTitles: ['Ce pack contient', 'Comment cela fonctionne ?']
        }
      ],
      extraPacksBottom: [
        {
          title: "Statuts seuls",
          subTitle: "Vous créez seul",
          price: `${third_price}€`,
          options: extraPackOptionsBottom("SARL"),
          todoOptions,
          id: 2,
          sectionTitles: ['Ce pack contient', 'Ce qu’il vous reste à faire']
        }
      ]
    },
    // creation-eurl 3 packs
    198: {
      headerTitle: "Votre EURL est prête à être créée",
      packHeaderDetails: headerDetails(first_price, second_price, feesPrice),
      faq: faq('EURL'),
      contentInfoDetails: getCompanyCreationDetails('EURL'),    
      extraPacksEC: [
        {
          title: "Création Offerte",
          subTitle: "Expert Comptable",
          price: 'Offerte',
          options: extraPackOptionsEC,
          todoOptions: todoOptionsEC,
          info: feesPrice ? displayFeesText(feesPrice) : null,
          id: 3,
          sectionTitles: ['Ce pack contient', 'Comment cela fonctionne ?']
        }
      ],
      extraPacksBottom: [
        {
          title: "Statuts seuls",
          subTitle: "Vous créez seul",
          price: `${third_price}€`,
          options: extraPackOptionsBottom("EURL"),
          todoOptions,
          id: 2,
          sectionTitles: ['Ce pack contient', 'Ce qu’il vous reste à faire']
        }
      ]

    },
    
    // creation-SAS 3 packs
    175: {
      headerTitle: "Votre SAS est prête à être créée",
      packHeaderDetails: headerDetails(first_price, second_price, feesPrice),
      faq: faq('SAS'),
      contentInfoDetails: getCompanyCreationDetails('SAS'),    
      extraPacksEC: [
        {
          title: "Création Offerte",
          subTitle: "Expert Comptable",
          price: 'Offerte',
          options: extraPackOptionsEC,
          todoOptions: todoOptionsEC,
          info: feesPrice ? displayFeesText(feesPrice) : null,
          id: 3,
          sectionTitles: ['Ce pack contient', 'Comment cela fonctionne ?']
        }
      ],
      extraPacksBottom: [
        {
          title: "Statuts seuls",
          subTitle: "Vous créez seul",
          price: `${third_price}€`,
          options: extraPackOptionsBottom("SAS"),
          todoOptions,
          id: 2,
          sectionTitles: ['Ce pack contient', 'Ce qu’il vous reste à faire']
        }
      ]
    },

    // creation-SASU 3 packs
    176: {
      headerTitle: "Votre SASU est prête à être créée",
      packHeaderDetails: headerDetails(first_price, second_price, feesPrice),
      faq: faq('SASU'),
      contentInfoDetails: getCompanyCreationDetails('SASU'),
      extraPacksEC: [
        {
          title: "Création Offerte",
          subTitle: "Expert Comptable",
          price: 'Offerte',
          options: extraPackOptionsEC,
          todoOptions: todoOptionsEC,
          info: feesPrice ? displayFeesText(feesPrice) : null,
          id: 3,          
          sectionTitles: ['Ce pack contient', 'Comment cela fonctionne ?']
        }
      ],
      extraPacksBottom: [
        {
          title: "Statuts seuls",
          subTitle: "Vous créez seul",
          price: `${third_price}€`,
          options: extraPackOptionsBottom("SASU"),
          todoOptions,
          id: 2,
          sectionTitles: ['Ce pack contient', 'Ce qu’il vous reste à faire']
        }
      ]
    },
  }
}



// WEBPACK FOOTER //
// ./src/constants/newCheckoutInfo.js